import { useState } from "react";
import { toast } from "sonner";
import { Check, Copy, ExternalLink } from "lucide-react";
import { Reveal } from "../components/Reveal";

const SPONSORS = [
  {
    name: "TEVEO",
    logo: "/sponsor-teveo.png",
    logoClass: "h-16 sm:h-20",
    discount: "-10%",
    code: "ESPOSTIGO",
    url: "https://teveo.com/discount/ESPOSTIGO",
    applied: true,
  },
  {
    name: "IO.GENIX",
    logo: "/sponsor-iogenix.png",
    logoClass: "h-10 sm:h-12",
    discount: "-10%",
    code: "DPOSTIGO",
    url: "https://tienda.iogenixnutrition.com",
    applied: false,
  },
];

async function copyCode(code) {
  try {
    await navigator.clipboard.writeText(code);
    return true;
  } catch {}
  try {
    const ta = document.createElement("textarea");
    ta.value = code;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

const SponsorCard = ({ sponsor, delay }) => {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    const ok = await copyCode(sponsor.code);
    if (ok) {
      setCopied(true);
      toast.success(`Código ${sponsor.code} copiado. Abriendo la tienda...`);
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast.error("No se pudo copiar. Anótalo: " + sponsor.code);
    }
  };

  return (
    <Reveal delay={delay} className="h-full">
      <a
        href={sponsor.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        data-testid={`rnb-sponsor-card-${sponsor.name.toLowerCase().replace(/[^a-z]/g, "")}`}
        className="group h-full border border-zinc-800 bg-[#0D0D0D] p-8 flex flex-col items-center text-center transition-colors duration-300 hover:border-zinc-500"
      >
        <div className="h-24 flex items-center justify-center">
          <img src={sponsor.logo} alt={`Logo de ${sponsor.name}`} loading="lazy" className={`${sponsor.logoClass} w-auto object-contain`} />
        </div>
        <p className="mt-6 font-display text-4xl text-white leading-none">{sponsor.discount}</p>
        <p className="mt-1 text-[10px] tracking-[0.3em] text-zinc-500 uppercase">de descuento con el código</p>
        <span className="mt-5 inline-flex items-center gap-3 border border-dashed border-zinc-600 px-5 py-3 font-display text-xl tracking-[0.2em] text-white group-hover:border-white transition-colors">
          {sponsor.code}
          {copied ? <Check className="h-4 w-4 text-white" /> : <Copy className="h-4 w-4 text-zinc-500 group-hover:text-white transition-colors" />}
        </span>
        <span className="mt-4 inline-flex items-center gap-2 text-[10px] tracking-[0.25em] text-zinc-500 uppercase group-hover:text-zinc-300 transition-colors">
          {sponsor.applied ? "Tienda con el código ya aplicado" : "Abrir la tienda y pegar el código al pagar"}
          <ExternalLink className="h-3 w-3" />
        </span>
      </a>
    </Reveal>
  );
};

const Sponsors = () => (
  <section data-testid="rnb-sponsors-section" className="py-20 lg:py-28 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">Marcas en las que confío</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl text-white leading-[0.95]">
          MIS CÓDIGOS DE DESCUENTO
        </h2>
        <p className="mt-4 text-base text-zinc-400 font-light max-w-xl mx-auto">
          Lo que yo uso, con descuento para ti. Toca una tarjeta: se copia el código y se abre la tienda.
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
        {SPONSORS.map((s, i) => (
          <SponsorCard key={s.name} sponsor={s} delay={0.1 + i * 0.08} />
        ))}
      </div>
    </div>
  </section>
);

export default Sponsors;
